import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BreadcrumbService, TypesUtilsService } from '@osos/shared/legacy-core';
import { BreadcrumbToken } from '@osos/shared/types';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [BreadcrumbModule, TranslateModule],
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  readonly home: MenuItem = {
    icon: 'icon-icon-material-home-2 icon-secondary',
    routerLink: '/',
  };
  items: MenuItem[] = [];
  loading = false;

  private _breadctumbTokens = Object.values(BreadcrumbToken).map((item) =>
    item.toString(),
  );
  private _unsubscribe$ = new Subject<void>();

  constructor(
    private breadcrumbService: BreadcrumbService,
    private trans: TranslateService,
    private typesUtils: TypesUtilsService,
  ) {}

  ngOnInit(): void {
    this.breadcrumbService.breadcrumbs$
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((items) => {
        if (
          items.some(
            (item) =>
              typeof item.label === 'string' &&
              this._breadctumbTokens.includes(item.label),
          )
        ) {
          this.loading = true;
          this.items = [];
          return;
        }

        this.items = items
          .filter((i) => !!i.label)
          .map((item) => ({
            label:
              typeof item.label === 'string'
                ? this.trans.instant(item.label)
                : this.typesUtils.getLocaleString(item.label),
            routerLink: item.url,
            queryParams: item.queryParams,
          }));

        this.loading = false;
      });
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
